//#region Styles
import { ContainerParts } from "components/styles";
import PublicPartForm from "views/components/PublicPartForm/PublicPartForm";
//#endregion
//#region Components
import Part1 from "./components/Part1/Part1";
import Part2 from "./components/Part2/Part2";
//#endregion

const Step1 = ({
    loadingRequest, 
    dataRelatedToForm: {
        acadReinforceTypes,
        allCampus, payGradeList
    }, form, changeForm,
    errors, errorTexts
}) => {
    //#region Functions
    const changeFieldPart1 = (field, value, errorValue) => {
        changeForm("part1", field, value, errorValue);
    }
    const changeFieldPart2 = (field, value, errorValue) => {
        changeForm("part2", field, value, errorValue);
    }
    const changeFieldPart3 = (field, value, errorValue) => {
        changeForm("part3", field, value, errorValue);
    }
    //#endregion
    // Temporal
    const { id, ...publicLoadWithoutId } = form.part3.publicLoad;
    const part3WithoutId = {
        ...form.part3,
        publicLoad: publicLoadWithoutId
    };
    return (
        <ContainerParts>
            <Part1 form={form.part1}
                changeField={changeFieldPart1}
                errors={errors.part1}
                acadReinforceTypes={acadReinforceTypes}/>
            <Part2 
                loadingRequest={loadingRequest}
                data={{
                    payGradeList
                }}
                form={form.part2}
                changeField={changeFieldPart2}
                errors={errors.part2}
                errorTexts={errorTexts}/>
            <PublicPartForm 
                form={part3WithoutId}
                titleListSecion="¿A quiénes está dirigido el refuerzo?"
                changeField={changeFieldPart3}
                errors={errors.part3}
                allCampus={allCampus}
                errorTexts={errorTexts}
                formatFileListSection="/Documents/formato_publico_codigo_estudiantes.xlsx"
                as="refuerzo"/>
        </ContainerParts>
    );
}

export default Step1;